<template>
  <div id="app">
    <router-view></router-view>
    <div v-title class="main" data-title="Q-NEX管理后台">
    </div>
  </div>

</template>

<script>
export default {
  name: 'App',

}
</script>




// WEBPACK FOOTER //
// src/App.vue